import 'lazysizes';
import '../Helper';
import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import collapse from '@alpinejs/collapse';
import './Presentation/Atom/Arrow/Arrow';
import './Presentation/Atom/Video/Video';
import './Presentation/Atom/TextSlider/TextSlider';
import './Presentation/Molecule/AnimatedBackground/AnimatedBackground';
import './Presentation/Molecule/CookieConsent/CookieConsent';
import './Presentation/Molecule/LogoSlider/LogoSlider';
import './Presentation/Molecule/PageSlider/PageSlider';
import './Presentation/Molecule/Stat/Stat';
import './Presentation/Molecule/Slider/Slider';
import './Presentation/Molecule/YoutubePlayer/YoutubePlayer';
import './Presentation/Organism/BrowserMockup/BrowserMockup';
import './Presentation/Organism/Header/Header';
import './Presentation/Organism/Hero/Hero';

Alpine.plugin(focus);
Alpine.plugin(collapse);

// We use this to enable the AlpineJS debugger in the browser.
if (!document.documentElement.dataset.debug) {
    window.Alpine = Alpine;
}

// Safari 11 polyfill for AlpineJS, see also https://github.com/alpinejs/alpine/discussions/1964
if (typeof window.queueMicrotask !== 'function') {
    window.queueMicrotask = function (callback) {
        Promise.resolve()
            .then(callback)
            .catch((e) =>
                setTimeout(() => {
                    throw e;
                })
            );
    };
}

Alpine.start();
